<nav class="navigation-tabs nav_mobile" role="navigation">
    <ul class="nav nav-pills">
        <li class="nav-item" >
            <a class="nav-link active" [ngClass]= "{'active': activeStatus.directionLink}"
            routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: false }"
            (click)="navigateTab(mobileDirectionLink)" (keyup.enter)="navigateTab(mobileDirectionLink)" tabindex="0"
            data-toggle="tab" [innerHTML]="directionMenuLabel"></a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-toggle="tab" [ngClass]= "{'active': activeStatus.mapLink}"
            routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: false }"
            (click)="navigateTab(mobileMapLink)" (keyup.enter)="navigateTab(mobileMapLink)" tabindex="0" [innerHTML]="mapsMenuLabel"></a>
        </li>
    </ul>
</nav>